import connect from '../connect';
import ACTIONS from '../../../store/actions';
import _logoutUser from '../../../page/NavBar/actions/logoutUser';

function withAuth(WrappedComponent) {
  var withRef = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return connect(mapStateToProps, mapDispatchToProps, null, {
    pure: false,
    withRef: withRef
  })(WrappedComponent);
}

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setAuth: function setAuth(authInfo) {
      return dispatch({
        type: ACTIONS.AUTH_SET,
        payload: authInfo
      });
    },
    logoutUser: function logoutUser() {
      return dispatch(_logoutUser());
    }
  };
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    auth: state.auth
  };
};

export default withAuth;